import type {
  DeviceMediaItem,
  DeviceSync,
  PlaybackIntent,
  ScheduleBoundary,
  TimedEventFire,
} from "@workspace/api-client-react";
import type { QueueEntry } from "@workspace/player-core";

export type { PlaybackIntent, ScheduleBoundary, TimedEventFire };

/** Audio surface program state (bed + interruptible insertions). */
export interface AudioProgramState {
  mode: "idle" | "bed" | "interrupt";
  current: QueueEntry | null;
  interruptQueue: QueueEntry[];
  bedPlaylistId: string | null;
}

/** Visual surface program state (signage rotation + visual insertions). */
export interface VisualProgramState {
  mode: "idle" | "signage" | "overlay" | "takeover";
  item: DeviceMediaItem | null;
  playlistId: string | null;
  playlistName: string | null;
  /** True when the visual should be force-muted (signage / visual_muted). */
  muted: boolean;
  /** True for av_full / av_takeover foreground presentation. */
  foreground: boolean;
  /** Per-item image duration override from the schedule entry. */
  imageDisplayDurationSec: number | null;
}

export function getTimedEvents(sync: DeviceSync | null): TimedEventFire[] {
  return sync?.timedEvents ?? [];
}

export function getBoundaries(sync: DeviceSync | null): ScheduleBoundary[] {
  return sync?.boundaries ?? [];
}

export function hasTimedAdEvents(sync: DeviceSync | null): boolean {
  return getTimedEvents(sync).some((e) => e.channelType === "ads");
}
